import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { Footer } from './footer.component';
import {
  selectFooterLinks,
  selectFooterStoreIcon,
  selectFooterStoreLink,
  selectFooterDisclaimer,
  selectFooterCopyright,
  selectIsFooterVisible,
} from '../../../modules/footer';

const mapStateToProps = createStructuredSelector({
  isVisible: selectIsFooterVisible,
  links: selectFooterLinks,
  storeIcon: selectFooterStoreIcon,
  storeUrl: selectFooterStoreLink,
  infoDisclaimer: selectFooterDisclaimer,
  copyrightInfo: selectFooterCopyright,
});

export const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(Footer);
